import Vue from 'vue';
import axios from 'axios';

Vue.prototype.$downloadFile = async function (filename, key) {
  try {
    const token = key || this.$store.state.token;
    const URL = `${process.env.VUE_APP_API_URL}/v1/requests/downloadFileGCS`;

    const response = await axios.post(URL, { filePath: filename }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const statusCode = response.status;
    if (statusCode === 200) {
      const link = response.data.fileUrl;
      window.open(link, '_blank');
    } else {
      this.$store.state.loader = false;
      this.$snackbar.showMessage({ message: "Download failed!", color: 'red' });
    }
  } catch (error) {
    this.$store.state.loader = false;
    this.$snackbar.showMessage({ message: "Download failed!", color: 'red' });
  }
};
